<template>
    <div class="sidebar-outline" :class="{closed: isClose, top: isTop}">
        <button type="button"
            id="btn-toggle"
            class="btn btn-outline-secondary btn-lg"
            :style="buttonStyle"
            :class="{closed: isClose, cloudy: isWriting}"
            @click="toggle()">
            <i class="fas fa-code-branch" v-if="isClose || (!isClose && !isTop)"></i>
            <i class="fas fa-times" v-else></i>
        </button>
        <div class="sidebar" :class="{closed: isClose}">
            <div class="sidebar-body">
                <div class="sidebar-wrapper">
                    <button type="button" class="btn btn-light btn-block btn-square" @click="toggle()">
                        閉じる
                        <i class="fas fa-chevron-right"></i>
                    </button>
                    <div class="list-group list-group-flush">
                        <a href="#" class="list-group-item list-group-item-action"
                            :class="{disabled: isEdit || $route.params.id == 'new'}"
                            @click.prevent="$emit('edit', null)">
                            <span v-if="!isEdit && $route.params.id != 'new'">
                                <i class="fas fa-bookmark"></i>
                                現在の版を保存する...
                                <span v-if="$store.state.max_versions <= versions.length">
                                    ({{versions.length - $store.state.max_versions + 1}} 件の古い履歴が消滅します)
                                </span>
                            </span>
                            <span v-else class="text-danger">
                                <i class="fas fa-ban"></i>
                                版管理を行う前に本文を保存してください。
                            </span>
                        </a>
                        <ul class="timeline">
                            <li v-for="(v, i) in versions" :key="v.id"
                                class="d-flex justify-content-start">
                                <div class="timeline-date">
                                    {{$filters.dateFormat(v.updated_at, "HH時mm分")}}
                                    <div class="small" v-if="isNewDate(i)">
                                        {{$filters.dateFormat(v.updated_at, "MM月DD日")}}
                                    </div>
                                </div>
                                <div class="timeline-content flex-fill">
                                    <h5 v-if="v.version_name">{{v.version_name||'無題'}}</h5>
                                    <div class="last-string" :class="{noname: !v.version_name, disabled: isEdit}" @click.prevent="selectVersion(v.id)">
                                        {{v.last_string}}
                                    </div>
                                    <div class="d-flex justify-content-between mb-3">
                                        <button type="button" class="btn btn-link btn-sm" @click.prevent.stop="editVersion(v.id)" :disabled="isEdit">
                                            <i class="fas fa-edit"></i>
                                            編集
                                        </button>
                                        <button type="button" class="btn btn-link btn-sm text-danger" @click.prevent.stop="removeVersion(v)" :disabled="isEdit">
                                            <i class="fas fa-times"></i>
                                            削除
                                        </button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="small py-2 px-3 text-right">
                        最大 {{$store.state.max_versions}} 版まで。
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style src="./sidebar.scss" scoped lang="scss"></style>
<style scoped lang="scss">
.timeline {
    list-style: none;
    padding-inline-start: 2rem;
    padding-inline-end: 1rem;
    li {
        margin: 0;
        overflow: hidden;
        position: relative;
    }
    .timeline-date {
        min-width: 100px;
        margin-top: 40px;
    }
    .timeline-content {
        border-left: 3px solid lightgreen;
        padding-left: 30px;
        h5 {
            padding: 10px .5rem 0;
            margin-bottom: 0;
        }
        .last-string {
            padding: .5rem;
            border-radius: .5rem;
            &:hover {
                background-color: rgba(192, 192, 192, .2);
                cursor: pointer;
            }
            &.disabled {
                opacity: .7;
                &:hover {
                    background-color: unset;
                    cursor: default;
                }
            }
        }
        .noname {
            margin-top: 2rem;
        }
        &:before {
            content: '\2022';
            font-size: 60px;
            position: absolute;
            left: 89px;
            color: lightgreen;
        }
        .btn-sm {
            font-size: .7rem;
        }
    }
}
</style>

<script>
export default {
    props: {
        isEdit: {
            required: true,
        },
        order: {
            default: 4
        },
        isWriting: {
            default: false,
        },
    },
    data() {
        return {
            isClose: true,
            isTop: false,
            selected_id: null,
            versions: [],
        }
    },
    methods: {
        load() {
            axios.get("/mypage/book/versions/get", {
                params: { id: this.$route.params.id }
            }).then(res => {
                this.versions = res.data;
            }).catch(err => { alert.err(err.response) });
        },
        toggle(isClose = null) {
            if (isClose !== null) {
                this.isClose = isClose;
                this.isTop = false;
            } else {
                if (!this.isClose && !this.isTop) {
                    this.isTop = true;
                } else {
                    this.isClose = !this.isClose;
                    this.isTop = !this.isClose;
                }
                this.$emit("toggle", this.isClose);
            }
        },
        selectVersion(id) {
            if (this.isEdit) return;
            this.selected_id = id;
            this.$emit("selected", id);
        },
        editVersion(id) {
            this.$emit("edit", id);
        },
        removeVersion(v) {
            const vname = v.version_name ? v.version_name : moment(v.updated_at).format("MM月DD日 HH時mm分");
            Swal.fire({
                title: "版を削除する",
                html: `<div class='small text-left'>
                        指定の版「<b>${vname}</b>」を削除します。<br>
                        よろしいですか？
                    </div>`,
                icon: "error",
                showCancelButton: true,
                confirmButtonText: "<i class='fas fa-times'></i>削除する",
                cancelButtonText: "キャンセル",
                confirmButtonColor: "crimson",
                cancelButtonColor: "gray",
                reverseButtons: true,
            }).then(confirm => {
                if (confirm.isConfirmed) {
                    axios.post("/mypage/book/version/remove", {id: v.id}).then(res => {
                        alert.msg(res.data);
                        this.load();
                    })
                }
            });
        },
        isNewDate(i) {
            if (i == 0) {
                return true;
            }
            const prev = moment(this.versions[i - 1].updated_at).date();
            const curr = moment(this.versions[i].updated_at).date();
            if (prev !== curr) {
                return true;
            }
            return false;
        }
    },
    computed: {
        buttonStyle() { return { "top": (this.order * 46 + 50) + "px" }; },
    },
    mounted() {
        this.load();
    }
}
</script>